import { NgModule } from '@angular/core';
import { DateFormatterPipe } from './date-formatter.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';
import { FormatDatePipe } from './format-date.pipe';
import { OrderBy } from './order-by-pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { OrderByDatePipe } from './order-by-date.pipe';
import { FilterPipe, SearchPipe } from './filter.pipe';
import { UniquePipe } from './uniq.pipe';
import { SafePipe } from './safe.pipe';
// import { SearchFilterPipe } from './search-filter.pipe';
 
@NgModule({
    imports: [],
    declarations: [DateFormatterPipe, PhoneNumberPipe, FormatDatePipe,OrderBy,OrderByDatePipe,SafeUrlPipe,FilterPipe, SearchPipe, UniquePipe,SafePipe],
    exports: [DateFormatterPipe, PhoneNumberPipe, FormatDatePipe, OrderBy, OrderByDatePipe,SafeUrlPipe, FilterPipe, SearchPipe, UniquePipe,SafePipe],
})

export class PipeModule {

    static forRoot() {
        return {
            ngModule: PipeModule,
            providers: [],
        };
    }
} 


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/pipe.module.ts